import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { StorageService } from '../Services/storage.service';
import { HttpQueriesService } from '../Services/http-queries.service';

@Component({
  selector: 'app-cvm-login-box',
  templateUrl: './cvm-login-box.component.html',
  styleUrls: ['./cvm-login-box.component.scss']
})
export class CvmLoginBoxComponent implements OnInit {

  auth = {email:null, pass:null};

  logging = false;
  con_user = null;

  @Input() loginBoxShow = {display:false};

  stillNotTheEvent = true;

  constructor(private router:Router, private httpservice:HttpQueriesService, private storagedata:StorageService) { 
    this.con_user = storagedata.getCongresConUser();
  }

  ngOnInit() {
  }

  showLoginBox(){
    this.loginBoxShow.display = true;
  }

  closeLoginBox(){
    this.loginBoxShow.display = false;
  }

  connect(){
    this.logging = true;
    this.httpservice.congresLogin(this.auth).subscribe(val=>{
      this.logging = false;
      this.storagedata.setCongresConUser(val);
      this.router.navigateByUrl('/congres-virtuel');
      this.auth = {email:null, pass:null};

    }, error=>{
      this.logging = false;
        
      if(error.error == 'cred'){
        alert("Votre identifiant / Mot de passe incorrect.");

      }else{
        alert("erreur d'authentification.");

      }

    });
   
  }

}
